import { render, staticRenderFns } from "./ownerMessage.vue?vue&type=template&id=407f9d7e&scoped=true&"
import script from "./ownerMessage.vue?vue&type=script&lang=js&"
export * from "./ownerMessage.vue?vue&type=script&lang=js&"
import style0 from "./ownerMessage.vue?vue&type=style&index=0&id=407f9d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f9d7e",
  null
  
)

export default component.exports